























































































import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { Option } from '~/models/shared/types'
import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'

import { defineComponent } from '~/utils/nuxt3-migration'
import { arraySchemaToObj } from '~/utils/form'
export default defineComponent({
  components: {
    CFormError,
    CTextArea
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    idToReport: {
      type: [Number, String],
      required: true
    },
    headerText: {
      type: String,
      required: false,
      default: ''
    },
    reportService: {
      type: Object,
      required: true
    },
    fetchMethodName: {
      type: String,
      required: true
    },
    postMethodName: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: 'lg'
    },
    static: {
      type: Boolean,
      required: false,
      default: false
    },
    extraClasses: {
      type: String,
      required: false,
      default: ''
    },
    reportParams: {
      type: Object,
      required: false,
      default: () => {}
    },
    modalToggle: {
      type: Boolean,
      default: false
    },
    modalInSearch: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false,
    reportSchema: null,
    form: {
      reason: {
        value: null,
        valid: true,
        errorMsg: null
      },
      details: {
        value: ''
      }
    },
    errorMsg: '',
    alreadyReported: [],
    hideFooter: false
  }),
  computed: {
    reasonsOptions(): Option {
      return (
        this.reportSchema.reason?.values ||
        this.reportSchema.report_reason?.options ||
        []
      ).map(v => ({
        text: v.name || v.label,
        value: v.value
      }))
    },
    isVisible: {
      get() {
        return this.show
      },
      set(newVisibilityState) {
        this.$emit('visibility-changed', newVisibilityState)
      }
    },
    idAlreadyReported() {
      return this.alreadyReported.includes(this.idToReport)
    }
  },
  methods: {
    async sendReport() {
      if (
        this.reportSchema &&
        (this.reportSchema.reason?.required ||
          this.reportSchema.report_reason?.required) &&
        this.form.reason.value === null
      ) {
        this.errorMsg = this.$t('please select a reason for the report')
        return
      }

      this.loading = true
      this.hideFooter = true
      try {
        const response = await this.reportService[this.postMethodName](
          this.idToReport,
          {
            reason: this.form.reason.value,
            details: this.form.details.value || null
          }
        )

        if (response?.data?.errors) {
          this.errorMsg = response.data.errors.reason
          this.hideFooter = false
        } else if (
          response.status === 200 ||
          response?.report ||
          response?.values
        ) {
          this.errorMsg = ''
          this.$snackbar.success(
            this.$i18n.t('your report has been submitted successfully')
          )

          this.isVisible = false

          this.alreadyReported.push(this.idToReport)
        }
      } catch (error) {
        if (error.response) {
          this.errorMsg = error.response.data.error
        }
        this.$logger.captureError(error)
        this.hideFooter = false
      } finally {
        this.loading = false
      }
    },
    hideModal() {
      this.isVisible = false
    },
    async modalShown() {
      if (!this.alreadyReported.includes(this.idToReport)) {
        this.errorMsg = ''
        this.reportSchema = null
        this.form.reason.value = null
        this.form.details.value = ''
      }

      if (!this.reportSchema) {
        this.loading = true
        const data = await this.reportService[this.fetchMethodName](
          this.idToReport,
          this.reportParams
        )
        const { schema } = data
        this.reportSchema = Array.isArray(schema)
          ? arraySchemaToObj(schema)
          : schema
        this.loading = false
      }
    }
  }
})
